import { makeStyles } from "@material-ui/core/styles";

const playStepContentStyles = makeStyles(() => ({
	mainContent: {
		height: "calc(100% - 90px)"
	}
}));

export default playStepContentStyles;
